const InitFilterObj = (columns) => {
  let newColumns = columns.filter((item) => item.field !== "actions");
  return newColumns.map((e) => ({
    name: e.field,
    label: e.headerName,
    value: "",
  }));
};
export default InitFilterObj;
